<template>
  <div>
    <!-- modal -->
    <b-modal
      id="modal-attach"
      ref="my-modal"
      title="แนบเอกสารเพิ่มเติม"
      ok-title="บันทึก"
      cancel-title="ยกเลิก"
      cancel-variant="outline-secondary"
      size="lg"
      centered
    >
      <form
        ref="form"
      >
        <b-form-group
          label="เลือกไฟล์"
          label-for="attach-input"
          invalid-feedback="กรุณาเลือกไฟล์"
        >
          <b-form-file
            id="attach-input"
            placeholder="เลือกไฟล์หรือลากมาวางที่นี่..."
            drop-placeholder="ลากไฟล์มาวางที่นี่..."
            multiple
          />
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BListGroup, BListGroupItem, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BFormFile,
    BButton,
    BFormGroup,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
}
</script>
